import { ILease, IResidentTableRow } from '@/types/admin/residentList';
import { capitalizeFirstLetter } from '@/utils/admin/utils';

export const getDateSubstr = (dateStr: string): string => {
  return dateStr.split('T')[0];
};

export const normalizeResidentRow = (row: ILease): IResidentTableRow => {
  const leaseCustomers = row.leaseCustomers || [];
  
  // Prioritize: 1) primary customer with account, 2) any customer with account, 3) primary customer, 4) first customer
  const primaryLeaseCustomer = 
    leaseCustomers.find(lc => lc.customer_type === 'primary' && lc.account) ||
    leaseCustomers.find(lc => lc.account) ||
    leaseCustomers.find(lc => lc.customer_type === 'primary') ||
    leaseCustomers[0];
    
  const primaryAccount = primaryLeaseCustomer?.account || (row.accounts && row.accounts[0]) || undefined;
  
  return {
    id: row.id,
    leaseId: row.id,
    name: primaryLeaseCustomer?.first_name
      ? `${primaryLeaseCustomer?.first_name} ${primaryLeaseCustomer?.last_name}`
      : 'No Details Found',
    lease_status: capitalizeFirstLetter(row.statusType || ''),
    unit: row.buildingUnitNumberSpace || '',
    last_login: primaryAccount?.lastInteractionDate
      ? new Date(getDateSubstr(primaryAccount?.lastInteractionDate))
      : null,
    last_payment: primaryAccount?.lastPaymentDate
      ? new Date(getDateSubstr(primaryAccount?.lastPaymentDate))
      : null,
    autopay: (row.recurringPayments?.length || 0) > 0,
    customer_type: capitalizeFirstLetter(primaryLeaseCustomer?.customer_type || ''),
    accountId: primaryLeaseCustomer?.id || primaryAccount?.id || 0,
  };
};


